import { useQuery } from '@tanstack/react-query';
import { getSalesForce } from 'services/api/requests/requests';

export const useSalesForceList = () => {
	return useQuery(['salesForce-list'], getSalesForce, {
		refetchOnWindowFocus: false,
	});
};
